<div class="kontainer" #kontainer>
  <button mat-icon-button (click)="aktiver()" color="primary" class="trigger" data-testid="fab-meny-trigger">
    <mat-icon [@fabTrigger]="{value: aktivert()}">add_circle</mat-icon>
  </button>

  @if (aktivert() && !menyinnslagDeaktivert()) {
    <div class="menyinnslag" @fadMeny (click)="deaktiver()">
      <ng-content/>
    </div>
  }
</div>

<!--
eksempel med bruk av overlay - men det virker overkill + vi ønsker å holder trigger og meny samlet for å kunne gi de en felles semitransp bakgrunn
<button mat-fab (click)="toggle()"
        cdkOverlayOrigin #trigger="cdkOverlayOrigin"
        class="trigger" data-testid="fab-meny" (mouseenter)="enter()" (mouseleave)="leave($event)"
        #fabMenyTrigger>
  <mat-icon [@fabTrigger]="{value: aktivert()}">add_circle</mat-icon>
</button>

<ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        cdkConnectedOverlayHasBackdrop="true"
        cdkConnectedOverlayBackdropClass="fab-meny-backdrop"
        cdkConnectedOverlayPanelClass="fab-meny-panel"
        [cdkConnectedOverlayPositions]="[{originX:'end', originY:'center', overlayX:'start', overlayY:'center', offsetX:10}]"
        [cdkConnectedOverlayOpen]="aktivert()"
        (backdropClick)="deaktiver()">
  @if (aktivert()) {
    <div class="kontainer" @fadMeny (click)="deaktiver()" #kontainer>
      <ng-content/>
    </div>
  }
</ng-template>
-->
